/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/17/20
 *
 */

const PriorityEnum = Object.freeze({
	URGENT: "URGENT",
	HIGH: "HIGH",
	MEDIUM: "MEDIUM",
	LOW: "LOW",
})

let priorityEnumArray = [{
	value: PriorityEnum.URGENT,
	label: "Urgent",
}, {
	value: PriorityEnum.HIGH,
	label: "High",
}, {
	value: PriorityEnum.MEDIUM,
	label: "Medium",
}, {
	value: PriorityEnum.LOW,
	label: "Low",
}]



let getPriorityObject = function (priority) {
	let res = priorityEnumArray.find(item => item.value === priority)
	return res
}

let getPriorityLabel = function (priority) {
	let res = priorityEnumArray.find(item => item.value === priority)
	return res ? res.label : ""
}

let getPriorityInputClass = function (priority){
	switch (priority){
		case PriorityEnum.URGENT:
			return "priority-urgent"
		case PriorityEnum.HIGH:
			return "priority-high"
		case PriorityEnum.MEDIUM:
			return "priority-medium"
		case PriorityEnum.LOW:
			return "priority-low"
	}
}

let getPriorityColorClass = function (priority){
	switch (priority){
		case PriorityEnum.URGENT:
			return "text-danger"
		case PriorityEnum.HIGH:
			return "text-warning"
		case PriorityEnum.MEDIUM:
			return "text-success"
		case PriorityEnum.LOW:
			return "text-primary"
	}
}


export {
	PriorityEnum,
	getPriorityLabel,
	priorityEnumArray,
	getPriorityInputClass,
	getPriorityColorClass,
	getPriorityObject
}

